const binding = { modules: {}, dataActions: {} };

    (binding.modules['content-block-with-selector'] = {
        c: () => require('partner/modules/content-block-with-selector/content-block-with-selector.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'content-block-with-selector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/content-block-with-selector'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|content-block-with-selector|content-block-with-selector'] = {
                c: () => require('partner/modules/content-block-with-selector/content-block-with-selector.view.tsx'),
                cn: '__local__-__local__-content-block-with-selector'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };